import { useDefinedParam } from '@storebrand-digital/react-hooks';

import { isProduct } from '../types/utils';

export default function useProduct() {
  const product = useDefinedParam('product');

  if (!isProduct(product)) {
    throw new Error(`The product param '${product}' is not a valid Product`);
  }

  return product;
}
